import { styled } from '@vw-marketing/us-components';

export const RecallContainer: any = styled.div`
  padding-bottom: 36px;
  border-bottom: solid 1px #dfe4e8;
  margin-bottom: 31px;
`;
export const FindDealerWrapper: any = styled.div`
  padding-top: 35px;
`;

export const HeadlineItemWrapper: any = styled.div`
  padding-bottom: 35px;
`;

export const TitleWrapper: any = styled.div`
  padding-bottom: 35px;
`;
interface RecallStatusProps {
  isImportant?: boolean;
}
export const RecallStatusWrapper: any = styled.div<RecallStatusProps>`
  color: ${(props: any) => (props.isImportant ? '#ff335c' : '#6a767d')};
  display: flex;
  align-items: center;
`;

export const RecallLabel: any = styled.div`
  margin-right: 5px;
  color: #000000;
`;
